export enum ViewMode {
    TABLE = 'TABLE',
    LIST = 'LIST',
}
